import { messageIdProvider, registerTranslationDivisions } from "infrastructure/localization";

export const securityDivision = "security";

registerTranslationDivisions([securityDivision]);

export const securityMessages = messageIdProvider(securityDivision);
